import { SectionBlockMediaContent } from "../sections/blocks/SectionBlockMediaContent";
import { Member } from "~/sanity/types";
import { WrapperNavSpacing } from "../wrappers/WrapperNavSpacing";
import { getPageSlug } from "~/styles/functions";

export interface ITemplateSingleMember {
  data: Member;
}

export default function TemplateSingleMember({ data }: ITemplateSingleMember) {
  const { firstname, lastname, image, text, role, socials, teams } = data;
  const tags = teams?.map((team) => ({
    label: team.shortTitle || team.title,
    link: {
      type: "internal",
      slug: getPageSlug(team.slug.current, team._type),
    },
  }));

  // console.log("templateSingleMember", data);

  const title = `${firstname} ${lastname}`;
  return (
    <WrapperNavSpacing>
      <SectionBlockMediaContent
        data={{
          title: title,
          image: image,
          text: text,
          subheading: role,
          link: {
            slug: socials?.linkedin || undefined,
            text: "View LinkedIn",
            type: "external",
            newTab: true,
          },
          tags: tags,
        }}
      />
    </WrapperNavSpacing>
  );
}
